import WRAP from "WRAP-JS";
import { AIRWAY_LEVEL_BOTH, AIRWAY_LEVEL_HIGH, AIRWAY_LEVEL_LOW } from "../../../components/map/layers/Airway";

/* eslint-disable */
WRAP.Renderer.AirwayLine = function() {
  WRAP.Renderer.GeoJSONExt.call(this);

  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  const superDraw = this.draw;
  let check;
  let level;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    check = {};
    level = conf.Attributes.level && conf.Attributes.level() || AIRWAY_LEVEL_BOTH;
    superDraw.apply(this, arguments);
  }

  this.drawFeature = function(layer, item, prop, ts) {
    const geo = item;
    const style = ts;
    if ( prop.preferred_route_type ) {
      return;
    }
    if (!!check[prop.gid]) {
      return;
    }
    check[prop.gid] = true;

    const targetLevel = (function() {
      switch(level) {
        case AIRWAY_LEVEL_BOTH:
          return ['B', 'H', 'L'];
        case AIRWAY_LEVEL_HIGH:
          return ['B', 'H'];
        case AIRWAY_LEVEL_LOW:
          return ['B', 'L'];
        default:
          return ['B'];
      }
    })();
    let currentArray = [];
    const coordinates = prop.fixes.reduce((accumulator, currentValue, currentIndex) => {
      if (targetLevel.includes(prop.level.charAt(currentIndex))) {
        if (currentArray.length === 0) {
          accumulator.push(currentArray);
        }
        currentArray.push(currentValue);
      } else {
        if (currentArray.length !== 0) {
          currentArray.push(currentValue);
          currentArray = [];
        }
      }
      return accumulator;
    }, []);
    const featureLine = new WRAP.Geo.Feature.GeoLine({
      path: coordinates,
      strokeStyle: style.line_color,
      lineWidth: style.line_width,
      geodesic: true,
      method: style.line_method
    });
    addFeature(layer, featureLine, geo, undefined);

  }
};
/* eslint-enable */